import React from 'react';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="banner-text">
        <h1>
          Half <span>Full</span> Stack Web Developer
        </h1>
        <hr />

        <p>HTML5 | CSS3 | vanilla JavaScript | React | jQuery</p>
        <p>
          My goal is to land junior web dev position. My current skill is HTML,
          CSS, JavaStript, React.
        </p>
        <div className="social-links">
          {/* Github */}
          <a
            href="https://github.com/michal-codes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-github-square" aria-hidden="true" />
          </a>
          {/* Twitter */}
          <a
            href="https://twitter.com/devdevmajki"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fa fa-twitter-square" aria-hidden="true" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
